<template>
  <div class="index_title" :class="{ 'index_title_page': page }">
    <div class="title">
      <div class="title_border left_border"></div>
      <div :class="{ 'english_title_page': page , 'english_title': true}">{{english_title}}</div>
      <div class="title_border right_border"></div>
    </div>
    <div :class="{ 'chinese_title_page': page , 'chinese_title': true}">{{chinese_title}}</div>
  </div>
</template>

<script>
export default {
  props: ["english_title","chinese_title","page"]
}
</script>

<style>
.index_title{
  margin: 50px 0;
}
.index_title .title{
  display: flex;
  justify-content: center;
  align-items: center;
}
.index_title .title_border{
  border: 1px solid #00a0e9;
  width:50%;
  height: 0;
  /* margin: 0 15px; */
}
.index_title .english_title{
  color:#00a0e9;
  white-space:nowrap;
  font-size: 26px;
  /* 強迫不換行 */
}
.index_title .chinese_title{
  text-align: center;
  margin-top: 10px;  
  font-size: 19px;
}
.left_border{
  margin-right: 20px;
}
.right_border{
  margin-left: 20px;
}

.index_title .chinese_title_page{
    font-size: 39px;
    font-weight: 700;
}
.index_title_page{
    max-width: 1200px;
    margin: 50px auto;
    padding: 0 15px;
}
  @media (max-width: 768px){
      .index_title_page{
          margin: 20px auto;
      }
      .index_title .english_title_page{
          font-size: 19px;
      }
      .index_title .chinese_title_page{
          font-size: 29px;
      }
  }
</style>
